import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content-core';
import { stringInputSpec } from './editing-configs';
import UniversalContainer, {
  universalContainerPropTypes,
} from '../components/universal-container';

const TikTokPlayer = (props) => {
  const { tiktokURL, mediaContainer } = props;

  return (
    <UniversalContainer
      {...mediaContainer}
      width="100%"
      data-testid="TikTokPlayer"
    >
      <StructuredContent>
        {{
          type: 'TikTok',
          version: '1.0.0',
          props: {
            url: tiktokURL,
          },
        }}
      </StructuredContent>
    </UniversalContainer>
  );
};

TikTokPlayer.getEditingConfig = (_componentDocument, fieldName) => {
  const getInputName = (name) => {
    return `${fieldName?.split('.').at(-1)}.${name}`;
  };
  return [
    stringInputSpec(getInputName('tiktokURL'), 'Tiktok Video URL', {
      help: 'Provide here the full TikTok video URL',
    }),
  ];
};

TikTokPlayer.displayName = 'TikTok Player';
TikTokPlayer.propTypes = {
  tiktokURL: PropTypes.string,
  mediaContainer: universalContainerPropTypes,
};

export default TikTokPlayer;
